import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { useDispatch } from 'react-redux';

import Loader from '../../../components/Loader';
import NotFound from '../../notFound/NotFound';
import EditProfileInfo from '../../../components/siteadmin/EditProfile/EditProfileInfo';
import { censorEmail, censorPhone, decode } from '../../../helpers/secureEmail';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';

import { showUserProfile } from '../../../lib/graphql/user';
import { withQuery } from '../../../hoc/withGraphql';

const EditProfile = (props) => {

    const [isRestrict, setIsRestrict] = useState(false);
    const dispatch = useDispatch();
    const { data: { loading, showUserProfile }, profileId } = props;

    useEffect(() => {
        async function fetchData() {
            const isRestrict = await dispatch(demoRestrictionEncode());
            setIsRestrict(isRestrict);
        }
        fetchData();
    }, []);

    let initialValues = {};
    if (loading) {
        return <Loader type={"text"} />
    }
    if (!showUserProfile) {
        return <NotFound />
    }
    if (showUserProfile) {
        initialValues = {
            ...showUserProfile,
            phoneNumber: !isRestrict ? decode(showUserProfile?.phoneNumber) : censorPhone(decode(showUserProfile?.phoneNumber)),
            profileBanStatus: {
                email: !isRestrict ? decode(showUserProfile?.profileBanStatus?.email) : censorEmail(decode(showUserProfile?.profileBanStatus?.email))
            },
            isRestrict
        };
    }
    return (
        <>
            <EditProfileInfo profileId={profileId}
                initialValues={initialValues} />
        </>
    )
}

EditProfile.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        showUserProfile: PropTypes.array,
    })
};

export default compose(
    withQuery(showUserProfile,
        {
            options: (props) => ({
                variables: {
                    profileId: props.profileId,
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }),
)(EditProfile);
